"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ThemeSwatch_1 = require("./ThemeSwatch");
var loadTheme_1 = require("owa-theme/lib/actions/loadTheme");
var mobx_react_1 = require("mobx-react");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var getAvailableThemeIds_1 = require("../utils/getAvailableThemeIds");
var React = require("react");
var styles = require('./Theme.scss');
var ThemeFull = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeFull, _super);
    function ThemeFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeFull.prototype.render = function () {
        var _this = this;
        return (React.createElement(FocusZone_1.FocusZone, { className: styles.fullSwatchContainer, direction: FocusZone_1.FocusZoneDirection.bidirectional, role: "listbox" }, getAvailableThemeIds_1.default().map(function (id) { return (React.createElement(ThemeSwatch_1.default, { themeId: id, key: id, onClick: _this.onThemeClick })); })));
    };
    ThemeFull.prototype.onThemeClick = function (themeId) {
        loadTheme_1.default(themeId);
    };
    ThemeFull = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThemeFull);
    return ThemeFull;
}(React.Component));
exports.default = ThemeFull;
//# sourceMappingURL=ThemeFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/view/ThemeFull.js
// module id = 4961
// module chunks = 2